import {connect} from 'react-redux';

import {selectCombinedFeatureFlags} from '../state/featureFlags/featureFlagsSelector';

export const injectFeatureFlags = (component) => {
  const mapStateToProps = (state) => {
    const featureFlags = selectCombinedFeatureFlags(state);
    return {featureFlags};
  };

  return connect(mapStateToProps)(component);
};
